import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var libraryPrefix = 'citrix-ui';
var knownDataKeys = ['data-testid', 'data-analytics-id', 'data-analyticsid'];
export function setDataAttributes(props, componentPrefix) {
  var dataProps = {};
  getDataAttributes(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (componentPrefix) {
      dataProps[key] = "".concat(libraryPrefix, "-").concat(componentPrefix, "-").concat(value);
    } else {
      dataProps[key] = value;
    }
  });
  return dataProps;
}
export function forwardDataAttributes(props) {
  var dataProps = {};
  getDataAttributes(props).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    dataProps[key] = value;
  });
  return dataProps;
}
function getDataAttributes(props) {
  return Object.entries(props).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      key = _ref6[0];
    return knownDataKeys.includes(key);
  });
}